module.exports = __webpack_public_path__ + "img/未标题-1_画板 1.18069c3a.jpg";